import { AxiosError, AxiosResponse } from 'axios';
import { useMutation, useQueryClient } from 'react-query';
import { showSnackbar } from 'components/shared/index';
import i18n from 'i18next';
import { showErrorSnackbar } from 'components/shared/Snackbar';
import showError from 'components/shared/showError';
import { useSaveResource } from 'RestAPIs/useSaveResource';
import {
  IMPORT_EMPLOYEE_CONFIG,
  IMPORT_EMPLOYEE_CONFIG_EMPLOYER
} from 'RestAPIs/endpoints';

export const useEditConfigs = ({ request, invalidateQueryKey, message }) => {
  const queryClient = useQueryClient();

  return useMutation<AxiosResponse, AxiosError, any>(request, {
    onSuccess: async (response) => {
      if (invalidateQueryKey) {
        await queryClient.invalidateQueries({
          queryKey: invalidateQueryKey
        });
      }
      showSnackbar({
        severity: 'success',
        message: message?.success ?? i18n.t('changesSaved')
      });
      return response;
    },
    onError: (error) => {
      message?.error ? showErrorSnackbar(message.error) : showError(error);
    }
  });
};

export const useSaveConnections = (data) => {
  const { mutateAsync: saveMain, isLoading } = useSaveResource({
    url: IMPORT_EMPLOYEE_CONFIG,
    id: data?.impEmployeeConfigId,
    invalidateQueryKey: ['importEmployeeConfig']
  });

  const { mutateAsync: saveEmployees, isLoading: isLoadingEmployees } =
    useSaveResource({
      url: IMPORT_EMPLOYEE_CONFIG_EMPLOYER,
      invalidateQueryKey: ['importEmployeeConfigEmployer']
    });

  return {
    saveMain,
    saveEmployees,
    isLoading: isLoading && isLoadingEmployees
  };
};
